<template>
  <Commerce-Card
    :class="variant === 'category'
      ? 'flex h-20 items-center justify-between p-4 lg:p-3'
      : 'flex h-48 flex-col gap-4 p-5'"
  >
    <!-- Category card skeleton -->
    <template v-if="variant === 'category'">
      <div class="flex items-center gap-3">
        <div class="skeleton h-10 w-10 shrink-0" />
        <div class="space-y-2">
          <div class="skeleton h-4 w-28" />
          <div class="skeleton h-3 w-16" />
        </div>
      </div>
      <div class="skeleton h-4 w-4" />
    </template>

    <!-- Service card skeleton -->
    <template v-else>
      <div class="flex items-start gap-3">
        <div class="skeleton h-10 w-10 shrink-0" />
        <div class="flex-1 space-y-2">
          <div class="skeleton h-4 w-3/4" />
          <div class="skeleton h-3 w-1/2" />
        </div>
      </div>
      <div class="space-y-2">
        <div class="skeleton h-3 w-full" />
        <div class="skeleton h-3 w-2/3" />
      </div>
      <div class="mt-auto flex items-center justify-between border-t border-border pt-3">
        <div class="skeleton h-3.5 w-20" />
        <div class="skeleton h-3.5 w-16" />
      </div>
    </template>
  </Commerce-Card>
</template>

<script setup lang="ts">
defineProps<{ variant?: 'service' | 'category' }>()
</script>
